module.exports = __webpack_public_path__ + "img/hidden-costs.1277e453.png";